// src/features/links/linkUrl.ts
// IR-1047 — derive a clickable canonical URL from a LinkOnboardingRow.
//
// `link` (was `link_normalized`) is a deduplication key (e.g.
// "tg_public:albashiq720"), not a URL. The Join Links table needs a real URL
// for the user to click and for the column to read naturally. We reconstruct
// the canonical form from the normalized payload, disambiguating by
// `link_type` (H2 — tg_public vs tg_invite, wa_invite, signal_invite).
import type { LinkOnboardingRow } from "./types";

export function linkUrl(row: Pick<LinkOnboardingRow, "link" | "link_type">): string {
  const colon = row.link.indexOf(":");
  const payload = colon === -1 ? "" : row.link.slice(colon + 1);
  switch (row.link_type) {
    case "tg_public":
      return `https://t.me/${payload}`;
    case "tg_invite":
      return `https://t.me/+${payload}`;
    case "wa_invite":
      return `https://chat.whatsapp.com/${payload}`;
    case "signal_invite":
      return `https://signal.group/#${payload}`;
    default:
      return `https://${payload}`;
  }
}
